<template>

<div>
  <template   v-if=" hasCustomer">
    <span v-if="row.visible_for_customer">
      <eye-icon/>
    </span>
    <span v-else>
      <eye-off-icon/>
    </span>
  </template>
  <template v-else-if="!hasCustomer">
    <span v-if="row.is_public">
      <eye-icon/>
    </span>
    <span v-else>
      <eye-off-icon/>
    </span>
  </template>
</div>
</template>

<script>
export default {
  name: "PublicStateCell.vue",
  props: {
    row: {
      type: Object,
    }
  },
  computed: {
    hasCustomer() {
      return !!this.row.customer_id;
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
